import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_255: DocMigration = {
  maxSchemaVersion: "0.0.255",
  description: "Rename roomLayout to staticRoomLayout",
  apply(json: any) {
    if (json.roomLayouts) {
      json.staticRoomLayouts = json.roomLayouts;
      delete json.roomLayouts;
    }
    return json;
  },
};

export default migration_0_0_255;
